var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{attrs:{"title":_vm.title,"footer":false,"padding":0},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('div',{staticClass:"w-full",staticStyle:{"height":"calc(90vh - 50px)"}},[(_vm.visible)?_c('Main',{attrs:{"info":_vm.info}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }